// extracted by mini-css-extract-plugin
export var cell = "_6o-4";
export var headerCell = "_6o-2";
export var rowHeader = "_6o-3";
export var table = "_6o-1";
export var tableContainer = "_6o-0";